import UkCol from './src/uk-col';

/* istanbul ignore next */
UkCol.install = function(Vue) {
    Vue.component(UkCol.name, UkCol);
};

export default UkCol;


// WEBPACK FOOTER //
// ./packages/uk-col/index.js